import React from 'react';
import DeveloperAppSetupModal from '../apps/DeveloperAppSetupModal';

export default function SpotifyAppSetup(props) {
  return <DeveloperAppSetupModal provider="spotify" {...props} />;
}
